import { actions } from './actions'
import { mutations } from './mutations'

export const localizacao_unidades = {
  state: () => {
    return {
      unidades: [],
      loading: false
    }
  },
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/localizacao_unidades/index.js